export enum StudySpaceAnalyticEventKey {
    // Product = Study Space
    selectStudySpaceViewType = 'Select Study Space View Type',
    expandCollapseStudyDefinition = 'Expand/Collapse Linked Study Definition',
    expandCollapseAllStudyDefinitions = 'Expand/Collapse All Linked Study Definitions in Table',
    sortStudyDefinitionTable = 'Sort Study Definition Table',
    createStudySpace = 'Create Study Space',
    deleteStudyDefinition = 'Delete Study Definition',
    selectStudySpaceInListingsView = 'Select Study Space in Listings View',
    selectStudySpaceInGridView = 'Select Study Space in Grid View',
    filterStudySpace = 'Filter Study Space',
    updateStudySpaceGeneralInformation = 'Update Study Space General Information',
    renameStudySpace = 'Rename Study Space',
    deleteStudySpace = 'Delete Study Space',
    createStudyDefinition = 'Create Study Definition',
    selectStudyDefinitionInStudySpace = 'Select Study Definition in Study Space',
    duplicateStudyDefinition = 'Duplicate Study Definition',
    moveStudyDefinition = 'Move Study Definition',
    filterStudyDefinition = 'Filter Study Definition',
    changeStudyDefinitionStatus = 'Change Study Definition Status',
    logout = 'Logout',
    createSubstudy = 'Create substudy',
    createSubStudyFromMaster = 'Duplicate Master as Sub-study',
    clickSystemStatusLink = 'Click System Status Link',
    renameStudyDefinition = 'Rename Study Definition',
    importStudyDefinition = 'Import Study Definition',
    navigateToStudyDefinitionOriginLink = 'Navigate to Study Definition Origin Link',
    exportStudyDefinition = 'Export Study Definition',
    navigateTo = 'Navigate to',
    openPublishedReport = 'Open Published Report / Protocol Optimization',
    deletePublishedReport = 'Delete Published Report / Protocol Optimization',
    renamePublishedReport = 'Rename Published Report / Protocol Optimization',
    downloadPublishedReport = 'Download Published Report / Protocol Optimization',
}
